import { LiveKitClient } from "@share/live-kit/live-kit-classes/LiveKitClient";
import {
    DataPacket_Kind as DataPacketKind,
    Participant,
    ParticipantEvent,
    TrackPublication
} from "livekit-client";
import { SpeakerChecker } from "@share/web-conferences/helpers/SpeakerChecker";
import { UserProfilesService } from "@share/web-conferences/data/UserProfilesService";
import { StoreHelper } from "@share/web-conferences/helpers/StoreHelper";
import { LiveKitSpeakingController } from "@share/live-kit/controllers/LiveKitSpeakingController";
import { LiveKitQualityController } from "@share/live-kit/controllers/LiveKitQualityController";
import {
    runTimeoutForCurrentPresentation
} from "@share/web-conferences/helpers/slides/CurrentPresentationAbsenceHandler";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";
import { addPresenterAction } from "@share/web-conferences/store/actions";
import { stateKey } from "@share/web-conferences/helpers/StateKey";
import { AddPresentersParam } from "@share/web-conferences/types/AddPresentersParam";
import { UserProfile } from "@api/models/UserProfile";

export class LiveKitParticipantsEventsHandler {
    constructor(
        private readonly client: LiveKitClient,
        private readonly speakerChecker: SpeakerChecker,
        private readonly userProfilesService: UserProfilesService,
        private readonly storeHelper: StoreHelper,
        private readonly speakingController: LiveKitSpeakingController,
        private readonly qualityController: LiveKitQualityController,
        private readonly webConferenceService: WebConferenceService
    ) {

    }

    attachEventsToExisting() {
        this.client.room.participants.forEach(participant => {
            this.participantConnected(participant);
        })

        this.participantConnected(this.client.room.localParticipant);
    }

    participantConnected(participant: Participant) {
        console.log('participant', participant.identity, 'connected', participant.metadata);

        const userId = parseInt(participant.identity);

        if (this.speakerChecker.isSpeaker(userId)) {
            this.client.updateParticipant(participant);
            this.userProfilesService.fetchProfile(userId)
                .then((profile) => {
                    const key = stateKey(this.webConferenceService.schemaId, this.webConferenceService.objectId)

                    const alreadyHas = !!(this.storeHelper.store.state.webConference.presenters[key] as UserProfile[] | undefined)
                        ?.find((presenter: UserProfile) => presenter.userId === profile?.userId);

                    if(!alreadyHas) {
                        this.storeHelper.store.dispatch(addPresenterAction, {
                            key: key,
                            user: profile
                        } as AddPresentersParam);
                    }
                })
        }

        this.storeHelper.addJoinedUser(userId);

        participant
            .on(ParticipantEvent.TrackSubscribed, (_, pub: TrackPublication) => {
                console.log('subscribed to track', pub.trackSid, participant.identity);
                this.userProfilesService.fetchProfile(userId);

                this.client.updateParticipant(participant);
            })
            .on(ParticipantEvent.TrackUnsubscribed, (_, pub: TrackPublication) => {
                console.log('unsubscribed from track', pub.trackSid, pub.source);
                // this.client.tracksManager.remove(participant.identity);\
                this.client.updateParticipant(participant);

                this.storeHelper.removeJoinedUser(parseInt(participant.identity));

                if (!this.speakerChecker.isSpeaker(userId)) {
                    //if not speaker than most likely the user is banned or kicked out of the scene
                    this.client.tracksManager.remove(participant.identity);
                }
            })
            .on(ParticipantEvent.TrackMuted, (pub: TrackPublication) => {
                console.log('track was muted', pub.trackSid, participant.identity);
                this.client.updateParticipant(participant);
            })
            .on(ParticipantEvent.TrackUnmuted, (pub: TrackPublication) => {
                console.log('track was unmuted', pub.trackSid, participant.identity);
                this.client.updateParticipant(participant);
            })
            .on(ParticipantEvent.IsSpeakingChanged, (speaking) => {
                console.log('speaking changed', speaking);
                // this.updateParticipant(participant);
                this.speakingController.setStatus(participant.identity, speaking);
            })
            .on(ParticipantEvent.ConnectionQualityChanged, (connectionQuality) => {
                console.log('connection quality changed');
                this.qualityController.setQuality(participant.identity, connectionQuality)
            });

        // // eslint-disable-next-line @typescript-eslint/camelcase
        // participant.on(ParticipantEvent.DataReceived, (payload: Uint8Array, kind?: DataPacketKind) => {
        //     console.log('data received', participant)
        //     const data = this.decoder.decode(payload);
        //
        //     if (participant && data == ClientDataTypes.PresenterJoined) {
        //         this.userProfilesService.fetchProfile(userId);
        //         this.updateParticipant(participant);
        //     }
        // })
    }

    participantDisconnected(participant: Participant) {
        console.log('participant disconnected', participant.identity);
        this.client.tracksManager.remove(participant.identity);
        this.storeHelper.removeJoinedUser(parseInt(participant.identity));
        this.speakingController.remove(participant.identity);
        this.qualityController.remove(participant.identity);

        if (this.webConferenceService?.webConferenceData?.isSharingUser(parseInt(participant.identity))) {
            runTimeoutForCurrentPresentation(this.webConferenceService, this.storeHelper.store);
        }
    }
}
